import axios from 'axios'
import { baseUrl } from '../assets/Animations';
import { getRequestHeaders } from '../api';

const { getMonth, isBefore, isAfter, add, startOfWeek, endOfWeek, parseISO, eachDayOfInterval, startOfISOWeek, endOfISOWeek, isSameDay, getDay, getYear, getMinutes, getMilliseconds, getDate, getSeconds, getHours, differenceInCalendarWeeks, format, compareAsc } = require("date-fns");

export const createChatGptPrompt = async (students, teachers) => {
    //console.log(students)
    //console.log(teachers)
    let leavingStudents = findAllStudentsOfLeavingAndLeftTeachers(students, teachers)
    let allPossilbeTeachers = findReplacementTeachers('f513b7ea8395e', teachers, leavingStudents)
    let teachersCalendarEvents = await sortThisWeeksCalendarEventsForGoogleMapsAPI(allPossilbeTeachers)
    let locationArray = getLocationArray(leavingStudents, allPossilbeTeachers, teachersCalendarEvents)
    let driveTimes = await calculateAllDriveTimes(locationArray)


    let stringPrompt = generatePlacementPrompt(leavingStudents, allPossilbeTeachers, teachersCalendarEvents, driveTimes)
    //console.log(stringPrompt)
    let officialPromt = `I run a music school where teachers drive around to students' homes to teach lessons. I have a list of students who are losing their teacher and need a new one. I also have a list of teachers who are available and want more students. I need to match the students with the teachers. Here is the data I have: \n\n${stringPrompt}. Can you please give me an optimized schedule for the students and teachers using the google maps api to calculate the distance between the students' homes and the teachers' homes?`
    //copy to clipboard
    navigator.clipboard.writeText(officialPromt)
    alert('Prompt copied to clipboard')
}

const getCalendarEvents = async () => {
    return axios.get(`${baseUrl}/calendar/school/mor`, getRequestHeaders())
    .then((response) => {
        console.log(response.data)
        return response.data
    })
    .catch((error) => {
        console.log(error)
    })
}

function getLocationArray(leavingFamilies, possibleTeachers, calendarEvents) {
    let locationSet = new Set();

    // Extract student locations from leavingFamilies
    leavingFamilies.forEach(family => {
        if (family.familyAddress) {
            let address = `${family.familyAddress.addressLine1}, ${family.familyAddress.city}, ${family.familyAddress.state} ${family.familyAddress.zipcode}`;
            locationSet.add(address.trim());
        }
    });

    // Extract teacher locations from possibleTeachers
    possibleTeachers.forEach(teacher => {
        if (teacher.Address) {
            let address = `${teacher.Address.StreetAddress}, ${teacher.Address.City}, ${teacher.Address.State} ${teacher.Address.Zip}`;
            locationSet.add(address.trim());
        }
    });

    // Extract event locations from calendarEvents
    calendarEvents.forEach(event => {
        if (event.eventAddress) {
            let address = `${event.eventAddress.addressLine1}, ${event.eventAddress.city}, ${event.eventAddress.state} ${event.eventAddress.zipcode}`;
            locationSet.add(address.trim());
        }
    });

    // Convert Set to an array (removes duplicates)
    return Array.from(locationSet);
}

const generatePlacementPrompt = (leavingFamilies, possibleTeachers, calendarEvents, driveTimes) => {
    try {
        const studentsData = [];
        
        leavingFamilies.forEach(family => {
            family.students.forEach(student => {
                studentsData.push({
                    studentId: student.studentId,
                    studentName: student.studentName,
                    parentInstrument: student.instrumentList[0]?.parentInstrument || "Unknown",
                    lessonLength: student.lessonLength,
                    lessonAvailability: student.initialAvailability,
                    school: student.school,
                    familyId: family.familyId,
                    familyAddress: family.address
                });
            });
        });

        const teachersData = possibleTeachers.map(teacher => ({
            TeacherID: teacher.TeacherID,
            Name: teacher.Name,
            InstrumentList: teacher.InstrumentList.map(inst => inst.parentInstrument),
            School: teacher.School,
            AvailabilityDetails: teacher.AvailabilityDetails,
            WantsMoreStudents: teacher.WantsMoreStudents,
            Address: teacher.Address
        }));

        const eventsData = calendarEvents.map(event => ({
            teacherId: event.teacherId,
            dateTime: event.dateTime,
            lessonTime: event.time,
            lessonLength: event.lessonLength,
            recurring: event.recurring,
            studentId: event.studentId,
            eventAddress: event.familyAddress
        }));

        return JSON.stringify({
            studentsNeedingTeachers: studentsData,
            availableTeachers: teachersData,
            calendarEvents: eventsData,
            driveTimes: driveTimes
        }, null, 2);
    } catch (error) {
        console.error("Error generating placement prompt:", error);
        return "";
    }
};

export default generatePlacementPrompt;


const findAllStudentsOfLeavingAndLeftTeachers = (students, teachers) => {
    const leavingTeacherIDs = new Set(
        teachers
            .filter((teacher) => teacher.Status === 'leaving' || teacher.Status === 'Left School')
            .map((teacher) => teacher.TeacherID)
    );

    // Step 2: Filter families where any student has a teacher who is leaving and is active
    const studentsOfLeavingTeachers = students.filter((family) =>
        family.students.some((student) =>
            leavingTeacherIDs.has(student.teachersId) && student.studentStatus === 'Active'
        )
    );

    // Step 3: Update state and return results
    console.log(studentsOfLeavingTeachers);
    return studentsOfLeavingTeachers;
};

const findReplacementTeachers = (teacherId, teachers, families) => {
    try {
        let studentInstruments = new Set();
        let studentSchool = null;

        // Iterate through families to find all students of the given teacher
        families.forEach(family => {
            family.students.forEach(student => {
                if (student.teachersId === teacherId) {
                    student.instrumentList.forEach(inst => {
                        studentInstruments.add(inst.parentInstrument);
                    });
                    if (!studentSchool) {
                        studentSchool = family.school; // Assume all students are from the same school
                    }
                }
            });
        });

        // Convert Set to array for filtering
        const instrumentArray = Array.from(studentInstruments);
        console.log(instrumentArray)
        console.log(studentSchool)

        // Find teachers who teach these parentInstruments, are available, and at the same school
        const replacementTeachers = teachers.filter(teacher =>
            teacher.WantsMoreStudents &&
            teacher.Status === 'Active' &&
            teacher.School.toUpperCase() === studentSchool &&
            teacher.InstrumentList.some(inst => instrumentArray.includes(inst.parentInstrument))
        );
        console.log(replacementTeachers);
        return replacementTeachers;
    } catch (error) {
        console.error("Error finding replacement teachers:", error);
        return [];
    }
};

const sortThisWeeksCalendarEventsForGoogleMapsAPI = async (teachers) => {
    let events = await getCalendarEvents()
    let approvedDates = []
    for(let i = 0; i < events.length; i++){
        if(!events[i].isPendingOffer) {
            if(isOriginalDateThisWeek(events[i])) {
                isOriginalDateThisWeek(events[i]) && approvedDates.push(isOriginalDateThisWeek(events[i]))
            } else {
                hasRecurringDateThisWeek(events[i]) && approvedDates.push(hasRecurringDateThisWeek(events[i]))
            }
        }
    }
    //only return events that belong to a teacher in the teachers array
    approvedDates = approvedDates.filter((event) => {
        for(let i = 0; i < teachers.length; i++) {
            if(teachers[i].TeacherID === event.teacherId) {
                return true
            }
        }
    })
    console.log(approvedDates)
    return approvedDates
}

const isOriginalDateThisWeek = (e) => {
    const firstDayOfNextWeek = add(new Date(), {weeks: 1})
    const beginningOfWeekInFunction = startOfISOWeek(firstDayOfNextWeek)
    const endingOfWeekInFunction = endOfISOWeek(firstDayOfNextWeek)
    if(isAfter(new Date(e.dateTime), beginningOfWeekInFunction) && isBefore(new Date(e.dateTime), endingOfWeekInFunction)) {
        let clonedE = JSON.parse(JSON.stringify(e))
        clonedE.shadowDateTime = e.dateTime
        return checkIfShadowDateTimeConflictsWithRecurringEventException(clonedE)
    }
}

const checkIfShadowDateTimeConflictsWithRecurringEventException = (e) => {
    let foundConflict = false
    for(let i = 0; i < e.recurringExceptions.length; i++) {
        if(isSameDay(new Date(e.recurringExceptions[i]), new Date(e.shadowDateTime))) {
            foundConflict = true
        }
    }
    return foundConflict ? null : e
}

const hasRecurringDateThisWeek = (e) => {
    if(e.recurring.isOn) {
        return createShadowDateEvent(e)
    }
}

const createShadowDateEvent = (e) => {
    const firstDayOfNextWeek = add(new Date(), {weeks: 1})
    const beginningOfWeekInFunction = startOfISOWeek(firstDayOfNextWeek)
    if(e.recurring.frequency === 'weekly') {
        return findWhichDayOfThisWeekRecurringEventShouldBe(e)
    } else if (e.recurring.frequency === 'every-other-week') {
        if(differenceInCalendarWeeks(new Date(beginningOfWeekInFunction), new Date(e.dateTime)) % 2 === 0) {
            return findWhichDayOfThisWeekRecurringEventShouldBe(e)
        }
    }
}

const findWhichDayOfThisWeekRecurringEventShouldBe = (e) => {
    const firstDayOfNextWeek = add(new Date(), {weeks: 1})
    const beginningOfWeekInFunction = startOfISOWeek(firstDayOfNextWeek)
    const endingOfWeekInFunction = endOfISOWeek(firstDayOfNextWeek)
    const currentWeek = eachDayOfInterval({start: beginningOfWeekInFunction, end: endingOfWeekInFunction})
    if(isBefore(new Date(e.dateTime), endingOfWeekInFunction)) {
        for(let i = 0; i < currentWeek.length; i++) {
            if(getDay(new Date(currentWeek[i])) === getDay(new Date(e.dateTime))) {
                if(e.recurringEndDate !== '') {
                    if(isAfter(new Date(currentWeek[i]), new Date(e.recurringEndDate)) || isSameDay(new Date(currentWeek[i]), new Date(e.recurringEndDate))) {
                        return null
                    } else {
                        let clonedE = JSON.parse(JSON.stringify(e))
                        clonedE.shadowDateTime = new Date(getYear(currentWeek[i]), getMonth(currentWeek[i]), getDate(currentWeek[i]), getHours(parseISO(e.dateTime)), getMinutes(parseISO(e.dateTime)), getSeconds(parseISO(e.dateTime)), getMilliseconds(parseISO(e.dateTime))).toString()
                        return checkIfShadowDateTimeConflictsWithRecurringEventException(clonedE)
                    }
                } else {
                    let clonedE = JSON.parse(JSON.stringify(e))
                    clonedE.shadowDateTime = new Date(getYear(currentWeek[i]), getMonth(currentWeek[i]), getDate(currentWeek[i]), getHours(parseISO(e.dateTime)), getMinutes(parseISO(e.dateTime)), getSeconds(parseISO(e.dateTime)), getMilliseconds(parseISO(e.dateTime))).toString()
                    return checkIfShadowDateTimeConflictsWithRecurringEventException(clonedE)
                }
            }
        }
    }
}

// Function to create batch pairs (25 max per request)
function createBatches(arr, size) {
    let batches = [];
    for (let i = 0; i < arr.length; i += size) {
        batches.push(arr.slice(i, i + size));
    }
    return batches;
}

// Function to get drive times using batched API requests
async function getDriveTimes(origins, destinations) {
    let results = [];

    for (let origin of origins) {
        for (let destination of destinations) {
            if (origin !== destination) { // Avoid same-location requests
                const url = `${baseUrl}/getDriveTime?origin=${encodeURIComponent(origin)}&destination=${encodeURIComponent(destination)}`;

                try {
                    const response = await fetch(url);
                    const data = await response.json();

                    if (data.rows && data.rows[0] && data.rows[0].elements[0].status === "OK") {
                        let driveTime = data.rows[0].elements[0].duration.text;
                        console.log(`✅ Drive Time: ${origin} -> ${destination} = ${driveTime}`);

                        results.push({
                            origin,
                            destination,
                            driveTime
                        });
                    } else {
                        console.warn(`⚠️ No valid drive time for ${origin} -> ${destination}`);
                    }
                } catch (error) {
                    console.error(`❌ API Error for ${origin} -> ${destination}:`, error);
                }
            }
        }
    }

    return results;
}

// Run batched drive time calculations
async function calculateAllDriveTimes(locations) {
    let results = []; // Store all valid results

    // Create batches of up to 25 locations
    let originBatches = createBatches(locations, 25);
    let destinationBatches = createBatches(locations, 25);

    console.log(`🔄 Processing ${locations.length} locations in ${originBatches.length} batches...`);

    for (let originBatch of originBatches) {
        for (let destinationBatch of destinationBatches) {
            if (originBatch.length > 0 && destinationBatch.length > 0) {
                try {
                    let batchResults = await getDriveTimes(originBatch, destinationBatch);

                    // ✅ Ensure batch results are stored
                    if (batchResults.length > 0) {
                        console.log(`📥 Adding ${batchResults.length} results from this batch.`);
                        results.push(...batchResults);
                    } else {
                        console.warn(`⚠️ No results for batch: ${originBatch} -> ${destinationBatch}`);
                    }

                } catch (error) {
                    console.error("🚨 Batch failed, skipping:", error);
                }
            }
        }
    }

    console.log("✅ Final Drive Time Results:", JSON.stringify(results, null, 2));
    return results;
}

